import FrontEndApiService from './frontend.api.service';
import {setupEngine} from "@helpers/api-helper";
import JotFormDisclosureSessionAppResource
    from '@sellers-shield-home-protection/ss-core-js/src/AppResources/JotFormDisclosureSessionAppResource';
import {AppResourceSearch, ApiFilter} from '@sellers-shield-home-protection/ss-core-js';    
const JotformService = {

    /**
     * Makes a call to JotForm to check status of the Service
     * @returns Deactivated if site is having issues.
     */
    async checkMaintenance() {
        try {
            let config = setupEngine();
            const {data: {deactivated}} = await FrontEndApiService.get(`${config.apiPrefix}/${config.apiVersion}/form-pdf-toggle/`);
            return deactivated;
        } catch (error) {
            throw error;
        }
    },

    /**
      * Fetches JotForm Disclosure Session by DisclosureAppResource
      * @param disclosureUuid - DisclosureAppResource
      * @returns JotFormDisclosureSessionAppResource
      */
    async fetchJotFormDisclosureSessionByDisclosureUuid(disclosureUuid){
        if(!disclosureUuid){
            throw Error('Disclosure App Resource is required to obtain JotForm Disclosure Session.');
        }
        const searchData = {
            include: [
                'files',
                'form',
                'form.sections',
                'form.parentForm'
            ],
            pagination: 'disabled',
            filter: new ApiFilter({
                params: {
                    disclosureUuid: disclosureUuid,
                },
            }),
        };
        
        let jotFormDisclosureSessionAppResourceSearch = new AppResourceSearch('jot-form-disclosure-session');

        await jotFormDisclosureSessionAppResourceSearch.setSearchData(searchData);
        await jotFormDisclosureSessionAppResourceSearch.search();
        return jotFormDisclosureSessionAppResourceSearch;
    },
     /**
      * Fetches JotForm Disclosure Session by DisclosureAppResource
      * @param disclosureAppResource - DisclosureAppResource
      * @returns JotFormDisclosureSessionAppResource
      */
    async fetchJotFormDisclosureSession(disclosureAppResource) {
        return await this.fetchJotFormDisclosureSessionByDisclosureUuid(disclosureAppResource._uuid);
    },

    /**
     * @param form - Form 
     * @param order - Order
     * @param userUuid - User Uuid 
     * @param jotFormDisclosureSession - JotForm Disclosure Session (optional)
     */
    async getJotFormDisclosureSessionAppResource(form, order, userUuid, jotFormDisclosureSession = null) {
        return await this.getJotFormDisclosureSessionAppResourceByFormUuid(form?._uuid, order?.disclosure?.uuid, userUuid, jotFormDisclosureSession);
    },

    /**
     * @param formUuid - Form Uuid
     * @param order - Order
     * @param userUuid - User Uuid 
     * @param jotFormDisclosureSession - JotForm Disclosure Session (optional)
     */
    async getJotFormDisclosureSessionAppResourceByFormUuid(formUuid, disclosureUuid, userUuid, jotFormDisclosureSession = null) {
        if(!formUuid){
            throw Error('Form UUID is required to obtain a JotForm Disclosure Session.');
        }
        if(!disclosureUuid){
            throw Error('Disclosure App Resource is required to obtain a JotForm Disclosure Session.');
        }
        if(!userUuid){
            throw Error('User UUID is required to obtain a JotForm Disclosure Session.');
        }
        let jotFormDisclosureSessionAppResourceSearch = jotFormDisclosureSession;

        if(!jotFormDisclosureSessionAppResourceSearch){
            jotFormDisclosureSessionAppResourceSearch = await this.fetchJotFormDisclosureSessionByDisclosureUuid(disclosureUuid);
        }
        
        let session = formUuid && jotFormDisclosureSessionAppResourceSearch?.appResourceCollection
            ? jotFormDisclosureSessionAppResourceSearch.appResourceCollection.toArray().find(item => item.formUuid === formUuid)
            : null;

        if (!session) {
            session = new JotFormDisclosureSessionAppResource({
                attributes: {
                    formUuid: formUuid || null,
                    disclosureUuid: disclosureUuid,
                    userUuid: userUuid,
                },
            });
        }

        return session;
    },
};

export default JotformService;